module.exports = __webpack_public_path__ + "img/niu8.16c1f363.jpg";